import {Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService} from '../../_services/index';
import {User} from '../../_models/index';

import {Customs, LoginHelper, Role,} from '../../helpers';
import { Constants } from "../../helpers/constants";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';

const now = new Date();

@Component({
    standalone: false,
  selector: 'user-component',
  templateUrl: 'user.component.html',
  styleUrls: ['./user.component.scss'],
})

export class UserComponent implements OnInit, OnChanges {
  loading = false;
  @Input()
  user: User = <User>{};
  isSimpleView: boolean;
  currentUser: User;
  currentUserRole: Role;
  public error = '';
  roles: any;
  isMaster: boolean = false;
  isBossUser: boolean = false;
  isSelfEdit: boolean = false;

  allowedSelfEditRoles = {
    0: {16: true},
    1: {1: true},
    2: {2: true},
    4: {1: true, 4: true},
    8: {2: true, 8: true},
    16: {16: true},
    32: {32: true},
    64: {64: true},
    128: {128: true},
    256: {256: true},
    512: {512: true},
    1024: {1024: true},
    2048: {2048: true, 65536: true},
    4096: {4096: true, 65536: true},
    8192: {8192: true},
    16384: {16384: true},
    32768: {32768: true},
    65536: {65536: true},
    131072: {131072: true}
  }
  @Input()
  public externalRoles = null;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public alertService: AlertService,
    private constants: AppTextResourcesService) {

    this.roles = {
      1: 'User',
      2: 'Advisor Staff',
      4: 'Manager',
      8: 'Advisor Lead',
      16: 'Account Creator',
      32: 'King Admin',
      64: 'Vendor',
      128: 'Awareness',
      256: 'Admin',
      512: 'Assessor',
      1024: 'Survey',
      2048: 'Advisor Admin',
      4096: 'Customer Administrator',
      8192: 'Support',
      16384: 'Incident Response',
      32768: 'Workstream',
      65536: 'Platform Support',
      131072: 'Trust Center Viewer'

    };
  }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.alertService.suppressRootAlert.next(true);
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.currentUserRole = this.currentUser.role;
    console.log(this.allowedSelfEditRoles);
    console.log(this.allowedSelfEditRoles[this.currentUserRole]);
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }

    this.isMaster = tenantName == Constants.RiskSpongeMaster;
    if (this.user) {
      this.isSimpleView = (this.user.customs & Customs.SimpleView) != 0;
      this.isSelfEdit = this.user.userId == this.currentUser.userId;
      this.isBossUser = (this.user.role & (Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.PrimaryManager)) > 0;
    }
  }

  isConsultantManager() {

    return (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;
  }

  onSave() {
    this.loading = true;

    this.user.tenantName = LoginHelper.getTenantName();


    if (!this.user.firstName) {
      this.alertService.error("Please fill first name");
      this.loading = false;
      return;
    }

    if (!this.user.lastName) {
      this.alertService.error("Please fill last name");
      this.loading = false;
      return;
    }

    if (!this.user.lastName) {
      this.alertService.error("Please fill email address");
      this.loading = false;
      return;
    }

    if (!this.user.role) {
      this.alertService.error("Please select role");
      this.loading = false;
      return;
    }

    if (this.user.role == 64 && !this.user.companyName) {
      this.alertService.error("Please fill company name");
      this.loading = false;
      return;
    }

    if (this.user.secretQuestion1 && !this.user.secretAnswer1) {
      this.alertService.error("Please fill an answer for Question 1");
      this.loading = false;
      return;
    }

    if (this.user.secretQuestion2 && !this.user.secretAnswer2) {
      this.alertService.error("Please fill an answer for Question 2");
      this.loading = false;
      return;
    }

    if (this.user.secretQuestion3 && !this.user.secretAnswer3) {
      this.alertService.error("Please fill an answer for Question 3");
      this.loading = false;
      return;
    }

    if (this.isSimpleView) {
      this.user.customs |= Customs.SimpleView;
    } else {
      this.user.customs &= ~Customs.SimpleView;
    }

    console.log(this.user);
    if (this.user.userId) {
      this.userService.update(this.user)
        .subscribe(
          user => {
            this.loading = false;
            if (user.error) {
              this.alertService.error(user.error);
              return;
            }
            if (user.userId == this.currentUser.userId) {
              this.user.token = this.currentUser.token;

              sessionStorage.setItem('currentUser', JSON.stringify(this.user));
            }

            this.alertService.success('The user profile was updated.', true);
          },
          error => {
            this.loading = false;
            this.alertService.error(error._body || error);
          });
    } else {
      this.userService.create(this.user)
        .subscribe(
          user => {
            this.loading = false;
            if (user.error) {
              this.alertService.error(user.error);
              return;
            }
            this.alertService.success('The user profile was created.', true);

            this.loading = false;

          },
          error => {
            this.loading = false;
            this.alertService.error(error._body || error);
          });
    }
  }

  onInvite() {
    this.user.tenantName = LoginHelper.getTenantName();
    this.userService.invite(this.user,)
      .subscribe(
        user => {
          this.alertService.suppressRootAlert.next(false);
          this.alertService.success('Invitation email successfully sent', true);

          this.loading = false;
        },
        error => {
          this.loading = false;
          this.alertService.error(error);
        });

  }

  getSecretQuestions(): string[] {

    const questions = [
      null,
      "Mother's birthplace",
      "Best childhood friend",
      "Name of first pet",
      "Favorite teacher",
      "Favorite historical person",
      "Grandfather's occupation"
    ];

    return questions;
  }
}
